import { Check } from "lucide-react";
import { useRef } from "react";

export function PhotoStep({
	preview,
	onCapture,
	onPick,
	onClear,
	onConfirm,
}: {
	preview: string | null;
	onCapture: (file: File | undefined) => void;
	onPick: (file: File | undefined) => void;
	onClear: () => void;
	onConfirm: () => void;
}) {
	const captureRef = useRef<HTMLInputElement>(null);
	const pickRef = useRef<HTMLInputElement>(null);

	if (preview !== null) {
		return (
			<div className="flex flex-col items-start gap-4">
				<img
					src={preview}
					alt="Pré-visualização da sua foto"
					className="size-48 rounded-xl object-cover"
				/>
				<div className="flex flex-wrap gap-4">
					<button
						type="button"
						onClick={onConfirm}
						className="flex items-center gap-2 rounded-full bg-primary px-8 py-3 text-lg font-semibold text-primary-foreground shadow-control hover:bg-primary-hover"
					>
						Confirmar
						<Check className="size-4" />
					</button>
					<button
						type="button"
						onClick={onClear}
						className="rounded-xl bg-secondary px-8 py-3 text-lg font-medium text-foreground hover:bg-accent"
					>
						Trocar
					</button>
				</div>
			</div>
		);
	}

	return (
		<div className="flex flex-col gap-6">
			<div className="flex flex-wrap items-center gap-4">
				<input
					ref={captureRef}
					type="file"
					accept="image/*"
					capture="user"
					className="hidden"
					onChange={(e) => onCapture(e.target.files?.[0])}
				/>
				<input
					ref={pickRef}
					type="file"
					accept="image/*"
					className="hidden"
					onChange={(e) => onPick(e.target.files?.[0])}
				/>
				<button
					type="button"
					onClick={() => captureRef.current?.click()}
					className="rounded-xl bg-secondary px-8 py-5 text-xl font-medium text-foreground hover:bg-accent"
				>
					Tirar uma foto
				</button>
				<button
					type="button"
					onClick={() => pickRef.current?.click()}
					className="rounded-xl bg-secondary px-8 py-5 text-xl font-medium text-foreground hover:bg-accent"
				>
					Escolher do celular
				</button>
			</div>
		</div>
	);
}
